export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.systems': 'Search List(systems)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',

  'menu.workplace': 'Workplace',
  'menu.workplace.myWorkplace': 'My Workplace',
  'menu.workplace.myTaskDetails': 'My Data Insights',
  'menu.workplace.departmentTaskDetails': 'Team Data Insights',
  'menu.workplace.businessDataReport': 'Business Area Data Report',
  'menu.workplace.improveDashboard': 'Business Area Improvement Dashboard',
  'menu.workplace.roleImproveDashboard': 'Professional Line Improvement Dashboard',
  'menu.workplace.userImproveDashboard': 'Personnel Improvement Dashboard',
  'menu.workplace.myImproveDashboard': 'My Improvement Dashboard',
  'menu.workplace.myLikeCard': 'My Like Cards',
  'menu.workplace.teamGanttChart': 'Team Gantt Chart',
  'menu.workplace.personalGanttChart': 'Personal Gantt Chart',

  'menu.dashboard.dataDashboard': 'Production & Research Dashboard',
  'menu.dashboard.dataDashboard.productData': 'Requirement Delivery',
  'menu.dashboard.dataDashboard.country': 'Country Dashboard',
  'menu.dashboard.dataDashboard.industryLine': 'Industry Line Dashboard',
  'menu.dashboard.dataDashboard.professionalLineData': 'R&D Tasks',
  'menu.dashboard.dataDashboard.personalGanttChart': 'Personal Gantt Chart',
  'menu.dashboard.dataDashboard.teamGanttChart': 'Team Gantt Chart',
  'menu.dashboard.issue': 'Requirement Dashboard',
  'menu.dashboard.pool': 'Custom Requirement Pool',

  'menu.dashboard.organization': 'Production & Research Organization',
  'menu.dashboard.organization.weekly': 'Weekly Self-Reflection',
  'menu.dashboard.organization.weekly.send': 'Sent by Me',
  'menu.dashboard.organization.weekly.receive': 'Received by Me',
  'menu.dashboard.organization.weekly.all': 'All',
  'menu.dashboard.organization.weekly.department': 'Department Weekly Report',
  'menu.dashboard.organization.weekly.role': 'Product Weekly Report',
  'menu.dashboard.organization.weekly.project': 'Project Weekly Report',
  'menu.dashboard.organization.duty': 'Duty Roster',
  'menu.dashboard.organization.team': 'Personnel Distribution',
  'menu.dashboard.organization.team.structure': 'Organization Structure',
  'menu.dashboard.organization.team.structure.rd': 'R&D Center',
  'menu.dashboard.organization.team.structure.operation': 'Product Operations',
  'menu.dashboard.organization.team.assignment': 'Personnel Configuration',

  'menu.projectSet': 'Project Management',
  'menu.projectSet.spaceManagement': 'Space Management',
  'menu.projectSet.projectManagement': 'Project Record',
  'menu.projectSet.projectRelated': 'Related to Me',
  'menu.projectSet.projectResponsible': 'Responsible by Me',
  'menu.projectSet.projectFavorites': 'My Favorites',
  'menu.projectSet.projectViewable': 'Viewable by Me',
  'menu.projectSet.projectManagement.projectRelated': 'Related to Me',
  'menu.projectSet.projectManagement.projectResponsible': 'Responsible by Me',
  'menu.projectSet.projectManagement.projectFavorites': 'My Favorites',
  'menu.projectSet.projectManagement.projectViewable': 'Viewable by Me',
  // Old sub-menus commented out
  // 'menu.projectSet.issue': 'My Requirements',
  // 'menu.projectSet.task': 'My Tasks',
  // 'menu.projectSet.team.projectSet': 'Project List',
  // 'menu.projectSet.team.teamTeam': 'Project Overview',
  // 'menu.projectSet.team': 'Project Information',

  'menu.rd': 'R&D Collaboration',
  'menu.rd.businessIssue': 'Business Requirements',
  'menu.rd.productIssue': 'Product Requirements',
  'menu.rd.productIssueCreate': 'Create/Edit',
  'menu.rd.issueSearch': 'Requirement Search',
  'menu.rd.sprint': 'Iteration Planning',
  'menu.rd.detail': 'Details',
  'menu.rd.planning': 'Planning',
  'menu.rd.issues.poolShareDetail': 'Requirement Preview',
  'menu.rd.review': 'Meeting Center',
  'menu.rd.issues': 'Requirements',
  'menu.rd.tasks': 'Task Center',
  'menu.rd.test': 'Quality Management',
  'menu.rd.test.case': 'Test Cases',
  'menu.rd.test.minder': 'Case Details',
  'menu.rd.test.bug': 'Test Defects',
  'menu.rd.test.testBugCharts': 'R&D Process Quality',
  'menu.rd.deliveryQuality': 'Delivery Quality',
  'menu.rd.deliveryQuality.reBug': 'Regression Defects',
  'menu.rd.deliveryQuality.onlineBugs': 'Online Issues',
  'menu.rd.deliveryQuality.businessAcceptance': 'Business Acceptance',
  'menu.rd.deliveryQuality.productAcceptance': 'Product Acceptance',
  'menu.rd.deliveryQuality.incidentResponse': 'Incident Response',
  'menu.rd.deliveryQuality.accidentReportCreate': 'New',
  'menu.rd.plan': 'Planning',
  'menu.rd.statistics': 'Statistics',

  'menu.feedback': 'Feedback Management',
  'menu.feedback.board': 'Feedback Board',
  'menu.feedback.detail': 'Feedback Details',
  'menu.feedback.config': 'Configuration Management',

  'menu.chat': 'NextChat',
  'menu.chat.gemini': 'Gemini Pro',
  'menu.chat.qwenPlus': 'Qwen Plus',

  'menu.test': 'Test Management',
  'menu.test.case': 'Test Cases',
  'menu.test.minder': 'Case Details',
  'menu.test.report': 'Test Report',

  'menu.rd.test.bugCreate': 'Create Defect',
  'menu.rd.test.bugEdit': 'Edit Defect',
  'menu.rd.onlineBugCreate': 'Create',
  'menu.rd.onlineBugEdit': 'Edit',
  'menu.rd.deliveryQuality.reBugCreate': 'Create',
  'menu.rd.deliveryQuality.reBugEdit': 'Edit',
  'menu.delivery': 'Release Board',
  'menu.delivery.view': 'Delivery View',
  'menu.delivery.services': 'Service View',
  'menu.delivery.record': 'Release Record',
  'menu.delivery.gray': 'Gray Release',
  'menu.delivery.gray.view': 'Gray Observation',
  'menu.delivery.gray.graySetting': 'Frontend Gray Configuration',
  'menu.delivery.gray.backendGraySetting': 'Backend Gray Configuration',
  'menu.delivery.appointment': 'Release Calendar',
  'menu.delivery.k8s': 'K8s Cluster',
  'menu.delivery.service': 'Service Details',
  'menu.delivery.revision': 'Version Details',

  'menu.dashboard.efficiency': 'Efficiency Insights',
  'menu.dashboard.efficiency.dashboard': 'Requirement Delivery Overview',
  'menu.dashboard.efficiency.dashboard.dashboard': 'Requirement Delivery Overview',
  'menu.dashboard.efficiency.dashboard.requirementDashboard': 'Requirement Data Dashboard',
  'menu.dashboard.efficiency.dashboard.businessDashboard': 'Business Requirement Dashboard',
  'menu.dashboard.efficiency.workplace': 'Delivery Efficiency Dashboard',
  'menu.dashboard.efficiency.cost': 'Cost Insights',
  'menu.dashboard.efficiency.issueAndBug': 'Requirement Defect Details',
  'menu.dashboard.efficiency.monthlyReport': 'Monthly Report',
  'menu.dashboard.efficiency.scanner': 'Code Quality',
  'menu.dashboard.efficiency.quality': 'Quality Insights Dashboard',
  'menu.dashboard.efficiency.quality.testBugCharts': 'R&D Process Quality',
  'menu.dashboard.efficiency.quality.bugProcess': 'Bug Daily Clearance',
  'menu.dashboard.efficiency.quality.onlineBugProcess': 'Online Issue Daily Clearance',
  'menu.dashboard.efficiency.quality.onlineBugCharts': 'Online Delivery Quality',
  'menu.dashboard.efficiency.service': 'Delivery Capability Insights',
  'menu.dashboard.efficiency.service.serviceStatistics': 'Release Overview',
  'menu.dashboard.efficiency.service.serviceEmergencyStatistics': 'Emergency Release Overview',
  'menu.dashboard.efficiency.service.serviceCntBar': 'Release Trend',
  'menu.dashboard.efficiency.metric': 'Performance Metrics',
  'menu.dashboard.efficiency.metric.personalDashboard': 'Personal Dashboard',
  'menu.dashboard.efficiency.metric.teamDashboard': 'Team Dashboard',
  'menu.dashboard.efficiency.metric.businessDashboard': 'Business Dashboard',
  'menu.dashboard.efficiency.performance': 'Efficiency Measurement Score',
  'menu.dashboard.efficiency.performance.business': 'Efficiency Measurement Score',
  'menu.dashboard.efficiency.performance.personal': 'Efficiency Measurement Employee Score',
  'menu.dashboard.efficiency.scanner.sonar': 'Static Scanning',
  'menu.dashboard.efficiency.scanner.openSCA': 'Code Risk',
  'menu.dashboard.efficiency.model': 'Efficiency Score Model',
  'menu.dashboard.efficiency.health': 'Health Metrics',
  'menu.dashboard.efficiency.forecast': 'Delivery Forecast Dashboard',
  'menu.dashboard.efficiency.commit': 'Code Commit',
  'menu.dashboard.efficiency.commit.commitStatistics': 'Commit Statistics',
  'menu.dashboard.efficiency.commit.commitRecord': 'Commit Record',
  'menu.dashboard.efficiency.commit.commitChart': 'Commit Statistics Chart',
  'menu.dashboard.efficiency.commit.sonar': 'Static Scanning',
  'menu.dashboard.efficiency.commit.openSCA': 'Code Risk',
  'menu.dashboard.efficiency.analysis': 'Code Analysis',
  'menu.dashboard.efficiency.analysis.front-endOxlint': 'Frontend Oxlint',
  'menu.dashboard.efficiency.attendance': 'Working Hours Data',
  'menu.dashboard.efficiency.attendance.attendanceData': 'Attendance Data',
  'menu.dashboard.efficiency.attendance.workHourStatistics': 'Working Hours Statistics',
  'menu.dashboard.efficiency.attendance.workHourChart': 'Working Hours Chart',

  'menu.cmdb': 'CMDB',
  'menu.cmdb.dns': 'DNS Resolution',
  'menu.cmdb.dnsRecord': 'Resolution Settings',
  'menu.cmdb.aliyun': 'Alibaba Cloud',
  'menu.cmdb.aliyun.ecs': 'ECS',
  'menu.cmdb.aliyun.rds': 'RDS',
  'menu.cmdb.aliyun.polardb': 'PolarDB',
  'menu.cmdb.aliyun.region': 'Region',
  'menu.cmdb.aliyun.projectMeta': 'Resource Metadata',
  'menu.cmdb.aliyun.metricMetadata': 'Metric Metadata',

  'menu.itsm': 'ITSM',
  'menu.itsm.myProcessedTickets': 'My Processed',
  'menu.itsm.mySubmittedTickets': 'My Submitted',

  'menu.question': 'Issue Board',
  'menu.question.online': 'Online Issue Pool',
  'menu.question.record': 'Accident Review Record',

  'menu.techManagement': 'Technical Management',
  'menu.techManagement.accidentReport': 'Production Accident Report',
  'menu.techManagement.goeReview': 'COE Review',
  'menu.techManagement.technicalDebt': 'Technical Debt',
  'menu.techManagement.doc': 'Flowchart Board',
  'menu.techManagement.gocTimelineBoard': 'Goc Event Unified Board',

  'menu.tools': 'Tools',
  'menu.tools.logCenter': 'Germany Log Center',
  'menu.tools.notProd': 'Test Environment Logs',
  'menu.tools.webLog': 'WEB Log Center',
  'menu.tools.developLog': 'Develop Log Center',
  'menu.tools.iTopLog': 'iTop Log Center',
  'menu.tools.sls': 'SLS',
  'menu.tools.arms': 'ARMS Link Analysis',
  'menu.tools.clickVisual': 'ClickVisual',
  'menu.tools.polarDB': 'SlowSql',

  'menu.aiCoding': 'AiCoding',

  'menu.approval': 'Approval',
  'menu.approval.list': 'Approval',
  'menu.approval.sqlOrder': 'SQL Orders',

  'menu.subscribe': 'Subscribe',

  'menu.settings': 'Settings',
  'menu.settings.label': 'Label Management',
  'menu.settings.status': 'Status Data',
  'menu.settings.statusType': 'Status Management',
  'menu.settings.rejectNode': 'Reject Node Management',
  'menu.settings.template': 'Content Template Management',
  'menu.settings.industry': 'Industry Line Management',
  'menu.settings.service': 'Service Management',
  'menu.settings.business': 'Business Area',
  'menu.settings.workflow': 'Workflow Management',
  'menu.settings.approval': 'Approval Management',
  'menu.settings.metric': 'Efficiency Metric Management',
  'menu.settings.systemVersion': 'System Update Record',
  'menu.settings.likeCard': 'Like Card Management',

  'menu.slsDasbhoard': 'Observability Platform',
  'menu.slsDasbhoard.createOrderQps': 'Order API Performance',
  'menu.slsDasbhoard.wirelessLog': 'Wireless Log Visualization',
};
